<template>
  <div class="m-4 text-left pl-4 pr-4" style="background-color: white !important;">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>

    <div class="d-none d-lg-block">
      <div class="d-flex justify-content-between">
        <div class="d-flex">
          <b-button v-if="!edicionLinkUsuario" class="mt-4 ml-0" variant="outline-ligth"  @click="mostrarTipoHistoriaClinica(0)">
              <b-icon icon="arrow-left-circle"></b-icon>
            </b-button>
            <p
              class="solo-primera-mayus mt-4"
              style="font-size: 2em; font-family: 'Silene'"
            >
              Historia clínica
            </p>
        </div>
        <img src="@/assets/Imagotipo azul_b.png" alt="" style="width: 10em; height: 4em;">
      </div>
    </div>
    <div class="d-block d-lg-none text-center">
      <img src="@/assets/Imagotipo azul_b.png" alt="" style="width: 10em; height: 4em;">
      <div class="d-flex justify-content-center">
          <b-button v-if="!edicionLinkUsuario" class="mt-4 ml-0" variant="outline-ligth"  @click="mostrarTipoHistoriaClinica(0)">
              <b-icon icon="arrow-left-circle"></b-icon>
            </b-button>
            <p
              class="solo-primera-mayus mt-4"
              style="font-size: 2em; font-family: 'Silene'"
            >
              Historia clínica
            </p>
        </div>
    </div>

    <div class="p-4 mt-3 mb-4" style="font-size: .85em; line-height: 2; background-color: #FBF3DE; border-radius: 10px; padding-left: 3% !important;">
       <DatosCabecera
        :persona="infoPaciente.persona"      
      ></DatosCabecera>
    </div>
<b-row v-if="!edicionLinkUsuario" >
      <b-col sm="12" md="12" lg="6" xl="6">
        <b-alert v-if="copiado" variant="success" show
          >Se copió el enlace en tu portapapeles</b-alert
        >
<!--        <patient-journey-v2 v-else
                            :idPaciente="idPaciente"
                            :hc=true
        ></patient-journey-v2>-->
      </b-col>
      <b-col sm="12" md="12" lg="6" xl="6">
        Link de historia clínica:
        <b-button variant="link" @click="copiar" style="text-transform: none !important; width: 70%;">
          <p class="text-left text-link">{{ linkEnlace }}</p>
        </b-button>
      </b-col>
    </b-row>
    <hr>

    <b-form v-on:submit.prevent="enviarFormulario" >
    <div class="d-flex mt-4">
      <img class="img_subtitle" src="@/assets/hc/datos.png" alt="">
      <p class="subtitle">Datos del paciente</p>
    </div>

    <div class="mb-4">
      <DatosPacienteHC
        :persona="infoPaciente.persona"
        :listaEnterarse="listaEnterarse"
        :listaSexo="listaSexo"
        :cargandoPlanes.sync="cargandoPlanes"
        :cargandoCercania.sync="cargandoCercania"
        :cargandoConfianza.sync="cargandoConfianza"
        :cargandoMedio.sync="cargandoMedio"
      ></DatosPacienteHC>
    </div>
    
    <hr>

    <div class="d-flex mt-4">
      <img class="img_subtitle" src="@/assets/hc/datos.png" alt="">
      <p class="subtitle">¿Cómo te enteraste de dentalia?</p>
      <div class="mt-1 pl-1"><validacion></validacion></div>
    </div>

    <ComoTeEnteraste
      :persona="infoPaciente.persona"
      :listaEnterarse="listaEnterarse"
      :listaSexo="listaSexo"
      :cargandoPlanes.sync="cargandoPlanes"
      :cargandoCercania.sync="cargandoCercania"
      :cargandoConfianza.sync="cargandoConfianza"
      :cargandoMedio.sync="cargandoMedio"
    ></ComoTeEnteraste>

    <hr>

    <div class="d-flex mt-4">
      <img class="img_subtitle" src="@/assets/hc/datos.png" alt="">
      <p class="subtitle">Datos médicos</p>
    </div>

    <DatosMedicos
      :listaFormulario.sync="listaFormulario"  
    ></DatosMedicos>

    <hr>

    <div class="mt-4">
      <p class="text-justify">
              De conformidad con la norma oficial mexicana número
              NOM-004-SSA3-2012, los expedientes clínicos son propiedad del
              prestador de servicios que los genera, en ese tenor, no se podrán
              entregar constancias o documentos que forman parte del mismo, ni
              tampoco copia alguna, incluyendo estudios, radiografías, modelos,
              etc.
               El paciente como propietario de la información que
              proporciona para su atención odontológica y al ser beneficiario de
              los servicios médicos, tiene derecho de titularidad sobre la
              información para la protección de su salud, así como para la
              protección de la confidencialidad de sus datos en términos de
              nuestro aviso de privacidad.

              Manifiesto que todos los datos en la presente solicitud
              fueron declarados por mí, son verídicos y correctos.
            </p>        
      <div class="d-flex justify-content-center mt-3 mi-componente">        
        <p class="mr-2 semibold">He leído y acepto el aviso de privacidad.</p>
        <b-form-checkbox
           class="mi-checkbox-unico"
          name="terminos"
          v-model="infoPaciente.persona.aceptaAvisoPrivacidad"
          :state="
            infoPaciente.persona.aceptaAvisoPrivacidad != '' &&
            infoPaciente.persona.aceptaAvisoPrivacidad != null
          "
          required
          >
        </b-form-checkbox>
      </div>   
      
      <div class="text-center">
        <b-button
          class="mt-4 mb-4 pl-3 pr-3"
          type="submit"
          pill
          variant="primary"
          v-if="!enviando && (activarGuardar || edicionLinkUsuario)"
        >
          <p style="font-weight: 600; color: white !important;">Guardar</p>
        </b-button>
        <b-button variant="primary" v-show="enviando" disabled>
          <b-spinner small></b-spinner>
          Cargando...
        </b-button>
      </div>
    </div>
  </b-form>







<!--  -->
  </div>
</template>
<script>
import VueNotifications from "vue-notifications";
import { LoginService } from "@/apiServices/login/LoginService";
import moment from "moment/moment";
import DatosCabecera from "./DatosCabecera.vue";
import DatosPacienteHC from "@/views/perfilPacientes/historialClinica/DatosPacienteHC";
import ComoTeEnteraste from "@/views/perfilPacientes/historialClinica/ComoTeEnteraste";
import DatosMedicos from "@/views/perfilPacientes/historialClinica/DatosMedicos";
//import PatientJourneyV2 from "@/components/PatientJourneyV2";

export default {
  name: "HistoriaClinicaV2",
  components: {
     DatosPacienteHC,
     ComoTeEnteraste,
     DatosMedicos,
     DatosCabecera
    },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    loginService: new LoginService(),
    headers: null,
    urlBase: null,
    copiado: false,
    existeFirma: false,
    idPaciente: null,
    nombrePlan: "",
    idPlan: null,
    listaConfianza: [],
    listaEnterarse: [],
    listaDolor: [],
    listaSexo:[],
    infoPaciente: {
      persona: {
        idPersona: null,
        apellidoMaterno: "",
        apellidoPaterno: "",
        nombre: "",
        fechaNacimiento: "",
        sexo: "",
        correo: "",
        telefono: "",
        casa: "",
        trabajo: "",
      },

       historia: {
        idClinica: null,
        idHistoriaClinica: null,
      },
      idPaciente: null
    },
    listaFormulario: [],
    listaEnviar: [],
    cargandoPlanes: true,
    cargandoDatosForm: true,
    cargandoMedio: true,
    cargandoCercania: true,
    cargandoConfianza: true,
    cargandoDolor: true,
    enviando: false,
    verFirma: false,
    formato: false,
    fechaNacimiento: null,
    idPacienteEncrip: null,
    idClinicaEncrip: null,
    idClinicaEncripPer: null,
    fechaActual: null
  }),
  props: {
    edicionLinkUsuario: Boolean,
    idHistoriaClinica: Number,
    activarGuardar: Boolean,
    idPacienteProp: Number,
    idClinicaProp: Number
  },
  async created() {
    this.debug = this.$localStorageService.getDebug();

    this.fechaActual = new Date();
    if (!this.edicionLinkUsuario) {
      this.idPaciente = this.$route.params.idPaciente;
      this.idClinica = this.$route.params.idClinica;
    }
    this.urlBase = this.$api;

    if (this.idPaciente === undefined || this.idPaciente === null) {
      this.idPaciente = this.$route.params.id;
    }

    if (!this.edicionLinkUsuario) {
      this.idClinica = this.$localStorageService.getIdClinica();
      this.nombreClinica = this.$localStorageService.getNombreClinica();
      this.idPacienteEncrip = this.$global.encriptar(this.idPaciente);
      this.idClinicaEncrip = this.$global.encriptar(this.idClinica)
    } else {
      await this.generarToken();
      this.idPaciente = this.idPacienteProp;
      this.idClinica = this.idClinicaProp;
    }

    this.traerMedio();
    this.traerFormulario()


    //si no trae datos de la base se colocan los de la sesion

    this.traerPlanes();
    this.vadicionActivarEceClinica();
    this.obtenerListaSexo();
  },
  methods: {
    mostrarTipoHistoriaClinica(tipoHc){
      this.$emit("mostrarTipoHistoriaClinica", tipoHc);
    },
    async generarToken() {
      const user = process.env.VUE_APP_ACCESS_HISTORIA_CLINICA_USER;
      const dato = process.env.VUE_APP_ACCESS_HISTORIA_CLINICA_DATE

      await this.loginService.login(user, dato).then(response => {
        this.headers = { 'headers': { 'Authorization': response.Authentication}}
      });
    },
    verificarExisteFirma(value) {
      this.existeFirma = value;
    },
    traerPlanes() {
      this.cargandoPlanes = true;
      const datos = {
        idPaciente: this.idPaciente
      }
      let urlPlanes =
        this.urlBase +
        "paciente/perfiles/obtenerPlanesPaciente";

      this.$http
        .post(urlPlanes, datos, this.headers)
        .then((response) => {
          if (response.data.data) {
            let idPlan = null;
            let nombrePlan = "";
            response.data.data.forEach((plan) => {
              idPlan = plan.id;
              nombrePlan = plan.nombre;
            });
            this.idPlan = idPlan;
            this.nombrePlan = nombrePlan;
            this.cargandoPlanes = false;
          }
        })
        .catch((err) => {
          this.errorMensaje(err);
          this.cargandoPlanes = false;
        });
    },
    traerMedio() {
      let urlMedio = this.urlBase + "paciente/catalogo/listaMedio";
      this.$http
        .get(urlMedio, this.headers)
        .then((response) => {
          if (response.data.data) {
            this.listaEnterarse = response.data.data;
            this.validarIdMedioActivo();
          }
        })
        .catch((err) => {
          this.errorMensaje(err);
        })
        .finally(() => {
          this.cargandoMedio = false;
        });
    },

    /*
    * Función para validar si el idMedio registrado por el paciente
    * sigue estando activo dentro de las opciones que se encuentran en la
    * pregunta ¿Cómo te enteraste de Dentalia?
    *
    * En caso de que no se resetea el valor idMedio de la Persona(Paciente) en
    * null para obligar a responder de nuevo la pregunta
    */
    validarIdMedioActivo() {
      const idMedio = this.infoPaciente?.persona?.idMedio;
      if (idMedio == null || !this.listaEnterarse?.length) return;
      const existe = this.listaEnterarse.some(g => g.options.some(o => o.idMedio === idMedio));
      if (!existe) this.infoPaciente.persona.idMedio = null;
    },

    traerFormulario() {
      const params = {
        idDenticion: 2
      }
      let urlForm =
          this.urlBase + "paciente/hc/obtenerFormulario";

      this.$http
          .post(urlForm, params, this.headers)
          .then((response) => {

            this.listaFormulario = response.data.data

          }).finally(() => {
          this.cargandoDatosForm = false;
          this.traerDatosPaciente();
      });
    },

     traerDatosPaciente() {

      if (this.idHistoriaClinica === undefined || this.idHistoriaClinica === null){
        this.idHistoriaClinica = 0
      }

      const params = {
        idPaciente: this.idPaciente,
        idHistoriaClinica: this.idHistoriaClinica
      }

      let urlPaciente =
        this.urlBase + "paciente/hc/obtenerDatosParametricos";

      this.$http
        .post(urlPaciente, params, this.headers)
        .then((response) => {
          if (response.data.data) {
            this.infoPaciente = response.data.data;
            this.validarIdMedioActivo();

            this.listaFormulario.forEach(l => {
              l.enfermedades.forEach(e => {
                this.infoPaciente.enfermedadesGuardar.forEach(g => {
                  if (e.idEnfermedadSistemica === g.idEnfermedadSistemica){
                      e.valor = g.valor;
                  }
                })
              })
            })

            //persona
            this.infoPaciente.persona.fechaNacimiento = this.$global.traerFechaLocal(
               moment(
                response.data.data.persona.fechaNacimiento
               )
                .utc()
                .format("MM/DD/YYYY")
            );

            //historial
            if (response.data.data.historia.idHistoriaClinica == null) {
              this.infoPaciente.historia.fechaModificacion = this.$global.traerFecha();
              if (!this.edicionLinkUsuario) {
                this.infoPaciente.historia.idClinica = this.idClinica;
                this.infoPaciente.historia.nombreClinica = this.nombreClinica;
              }
            }
          }
        })
        .catch((err) => {
          console.error(err);
        }).finally(()=> {
        if (this.infoPaciente.persona.fechaModificacion == null) {
          this.formato = true
          this.infoPaciente.persona.fechaModificacion = this.$global.traerFechaLocal(
              this.$global.traerFecha()
          );
        }
        this.idClinicaEncripPer = this.$global.encriptar(this.infoPaciente.persona.idClinica);
      });
    },
    enviarFormulario() {
      if (!this.validarDatos()) {
        this.guardarEditarhistoria();
      }
    },
    guardarEditarhistoria() {
      this.listaEnviar = [];
      this.fechaNacimiento = this.infoPaciente.persona.fechaNacimiento;

      let formularioValido = true;
      let enfermedadRequerida = [];

      this.listaFormulario.forEach(l =>{
        l.enfermedades.forEach(e => {
          if (e.valor !== null){
            this.listaEnviar.push({
              idEnfermedadSistemica: e.idEnfermedadSistemica,
              valor: e.valor
            })
          }else{
            if ((e.valor === null || e.valor === '') && e. requerido){
              formularioValido = false;
              enfermedadRequerida.push(e.descripcionEnfermedad);
            }
          }
        })
      })

      if (!formularioValido){
        this.$swal({
          icon: "warning",
          html: `Falta llenar campo requerido en:</br> <strong> ${enfermedadRequerida} </strong>, </br> Por favor llene todos los campos obligatorios `,
          confirmButtonColor: "#0e6ba9",
          cancelButtonColor: "#8e8e8e",
          confirmButtonText: "Ok",
          showCancelButton: true,
        })
      }else{
      this.infoPaciente.enfermedadesGuardar = this.listaEnviar;

            this.infoPaciente.persona.fechaNacimiento = this.infoPaciente.persona.fechaNacimiento
            this.infoPaciente.persona.fechaNacimiento = this.$moment(
                this.infoPaciente.persona.fechaNacimiento
            )
        if(this.idClinica != null){
          this.infoPaciente.persona.idClinica = this.edicionLinkUsuario ? this.idClinica : this.$localStorageService.getIdClinica();
        }else{
          this.infoPaciente.persona.idClinica = this.edicionLinkUsuario ? this.infoPaciente.persona.idClinica : this.$localStorageService.getIdClinica();
        }
        this.infoPaciente.persona.edicionLink = this.edicionLinkUsuario ? true : false;
        this.infoPaciente.persona.esEmergencia = false;

        if (this.formato){
          this.infoPaciente.persona.fechaModificacion = this.infoPaciente.persona.fechaModificacion
          this.infoPaciente.persona.fechaModificacion = this.$moment(
              this.infoPaciente.persona.fechaModificacion
          )
        }



          this.$swal({
            icon: "warning",
            text: "Estoy de acuerdo en que dentalia guarde mis datos de privacidad.",
            confirmButtonColor: "#0e6ba9",
            cancelButtonColor: "#8e8e8e",
            confirmButtonText: "Guardar",
            showCancelButton: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.enviando = true;
              this.enviarDatos();
            }
          });
      }
    },
    enviarDatos() {


      let urlEditar = this.urlBase + "paciente/historialDinamico";
      this.infoPaciente.idPaciente = this.idPaciente;

      this.$http
        .post(urlEditar, this.infoPaciente, this.headers)
        .then((response) => {
          if (response.status === 200) {
            this.enviando = false;
            this.$swal({
              icon: "success",
              text: "Se guardó su historial clínico correctamente",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
          }
        })
        .catch((err) => {
          this.enviando = false;
          this.errorEnvio(err);
        });
        this.infoPaciente.persona.fechaNacimiento = this.fechaNacimiento;
    },
    validarDatos() {
      let error = false;
      if (this.infoPaciente.persona.idMedio == null) {
        this.$swal({
          icon: "error",
          text:
              "Debe seleccionar una opción de '¿Cómo te enteraste de dentalia?'",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
        error = true;
      }
      
      return error;
    },

    /*acomodarDatos() {
      let historial = this.infoPaciente.historia;
      historial.idPaciente = this.idPaciente;

      if (this.edicionLinkUsuario) {
        historial.idClinica = this.infoPaciente.historia.idClinica;
      } else {
        historial.idClinica =
          this.infoPaciente.historia.idClinica != null
            ? this.infoPaciente.historia.idClinica
            : this.idClinica
      }

      historial.idPlan =
        this.infoPaciente.historia.idPlan != null
          ? this.infoPaciente.historia.idPlan
          : this.idPlan;
      delete historial.fechaModificacion;
      delete historial.nombrePlan;

      if (this.edicionLinkUsuario) {
        historial.usuarioLogeado = 1;
      } else {
        historial.usuarioLogeado = this.$localStorageService.getIdUsuario();
      }

      return {

        historia: historial,
        persona: {
          "casa": this.infoPaciente.persona.casa,
          "trabajo": this.infoPaciente.persona.trabajo,
          "telefono": this.infoPaciente.persona.telefono,
          "correo": this.infoPaciente.persona.correo,
          "sexo": this.infoPaciente.persona.sexo,
          "facebook": this.infoPaciente.persona.facebook,
          "twitter": this.infoPaciente.persona.twitter,
          idPersona: this.infoPaciente.persona.idPersona,
        }
      };
    },*/
    copiar() {
      var aux = document.createElement("input");
      aux.setAttribute("value", this.linkEnlace);
      document.body.appendChild(aux);
      aux.select();
      aux.setSelectionRange(0,99999);
      navigator.clipboard.writeText(aux.value)
      document.body.removeChild(aux);
      this.copiado = true;
      setTimeout(() => {
        this.copiado = false;
      }, 2000);
    },
    obtenerListaSexo() {
      let peticion = this.urlBase + "paciente/catalogo/listaSexo";
      this.$http
          .get(peticion, this.headers)
          .then((response) => {
            this.listaSexo = response.data.data;
          });
    },
    esLetra(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[A-Za-zÁÉÍÓÚáéíóúñÑ\s]+$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    async vadicionActivarEceClinica() {
      if (this.infoPaciente.persona.idClinica !== undefined && this.infoPaciente.persona.idClinica !== null) {
        const parametros = {idClinica: this.infoPaciente.historia.idClinica}
        await this.$http.post(
            this.$api + "catalogos/obtenerClinicasActivasECE", parametros
            , this.headers
        ).then((response) => {
          this.verFirma = response.data.data;
        });
      }
    },
  },

  mounted() {
    /*if (this.infoPaciente.historia.idHistoriaClinica == null) {
      this.infoPaciente.historia.fechaModificacion = this.$global.traerFecha();

      if (!this.edicionLinkUsuario) {
        this.infoPaciente.historia.idClinica = this.idClinica;
        this.infoPaciente.historia.nombreClinica = this.nombreClinica;
      }
    }*/
  },
  notifications: {
    errorMensaje: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al traer la información",
    },
    errorEnvio: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al enviar la información",
    },
  },
  computed: {
    linkEnlace: function () {
      if(this.infoPaciente.persona.idClinica != null){
        return (
          document.location.origin +
          "/historiaClinica/" +
          this.idPacienteEncrip +
          "/*" +
          this.idClinicaEncripPer
        );
      }else{
        return (
          document.location.origin +
          "/historiaClinica/" +
          this.idPacienteEncrip +
          "/*" +
          this.idClinicaEncrip
        );
      }
    },
  },
};
</script>
<style scoped>

.bordeIzquiero{
  border-right: 2px solid rgba(141, 135, 135, 0.22);
}

.table th, .table td {
  padding: 0.75rem;
  padding: 0.5rem;
  vertical-align: middle;
  border-top: 1px solid #fcfdff00;
  font-size: 12px;
}

@media only screen and (max-width: 380px) {
  .logoDentalia {
    width: 100%;
  }

  .fechaHc{
    width: 45%;
  }
}


.custom-switch{
  text-align: left !important;
}


.subtitulosHc, .subtitulosHc > .row,
.subtitulosHc-simple, .subtitulosHc-simple > .row{
  font-size: 18px;
  font-weight: bold;
  color: #ffffff !important;
  background-color: #17A2B8 !important;
  text-transform: uppercase;
  width: 100%;
  text-align: left;
  min-height: 50px;
  padding: 10px;
}

.solo-primera-mayus {
  text-transform: lowercase !important;    
}

.solo-primera-mayus::first-letter {
  text-transform: uppercase !important;   
}

p{
  margin: 0px;
  padding: 0px;
  color: #0046A2 !important;
}

.semibold{
  font-weight: 600;
}

.subtitle{
  font-size: 1.5em;
  font-weight: 700;
}

.img_subtitle{
  width: 2.4em;
  height: 2.2em;
  margin-right: 1%;
}
.mi-componente /deep/ .mi-checkbox-unico .custom-control-label::before {
  background-color: transparent !important;
  border: 2px solid #012247 !important;
  width: 1.5em !important;
  height: 1.5em !important;

}

.mi-componente /deep/ .mi-checkbox-unico .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #C4E39B !important;
  border-color: #012247 !important;
}

.mi-componente /deep/ .mi-checkbox-unico .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23012247' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e") !important;
  width: 1.5em !important;
  height: 1.5em !important;
}

.text-link{
  white-space: normal;     
  overflow-wrap: break-word; 
  word-break: break-word;   
  width: 100%;
}
</style>
